import { Service } from '@angular/core';
import { PageState, PageStateBase, PageStateService, PageDataServiceBase } from '@portal-core/data/page/services/page.state';
import { OutputAnalyticsKey } from '@portal-core/output-analytics/models/output-analytics-key.model';
import { OutputAnalyticsKeyState } from '@portal-core/output-analytics/services/output-analytics-key/output-analytics-key-data.service';

@PageState({
  name: 'outputAnalyticsPageState',
  actionName: 'OutputAnalyticsPage'
})
export class OutputAnalyticsPageState extends PageStateBase {}

@Service()
@PageStateService<OutputAnalyticsKey>({
  pageState: OutputAnalyticsPageState,
  itemCollectionState: OutputAnalyticsKeyState
})
export class OutputAnalyticsPageDataService extends PageDataServiceBase<OutputAnalyticsKey> {
  override state = OutputAnalyticsPageState;
}
